// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TemplateSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TemplateSaveInput — body for POST /franchisor-channels/template-save.
 *
 * Every (trigger_key x channel_type) pair is pt-BR seeded idempotently at
 * boot (Franchisor_channel_templates_model::ensureDefaultTemplates()) —
 * there is no "create a template" action, only editing an existing one, so
 * `id` is required, never null.
 *
 * `updated_by` is NOT read from this input — the controller stamps it from
 * the authenticated staff user, never from client-supplied data.
 *
 * Validated by the controller (needs the target row's trigger_key to know
 * the allowed-vars list): a `{{var}}` in `body` (or `subject`, email-only)
 * outside FranchisorTriggerCatalog::allowedVars($triggerKey) is refused
 * 'unknown_template_var:<name>'.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_TemplateSaveInput {
id: number
body: string
subject?: string
}

registerContract('FranchisorChannels_TemplateSaveInput', {
  id:      { type: 'number',  required: true },
  body:    { type: 'string',  required: true },
  subject: { type: 'string',  required: false },
})
